<mat-toolbar class="bar-filler"></mat-toolbar>
<div class="map-container" id="map"></div>
<button mat-raised-button id="confirmButton" color="primary" style="position: fixed; bottom: 15px; left: 50%; transform: translate(-50%,-50%);">{{'Pages.PickLocation.Confirm' | translate}}</button>
<mat-toolbar color="primary" class="top-bar" id="topbar">
    <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div>{{'Pages.PickLocation.Title'| translate}}</div>
</mat-toolbar>